(function () {
  'use strict';

  /*
   * BOU Upsell + producto principal + descuento real
   *
   * Códigos esperados en Shopify:
   * - BOU-UPSELL-1: descuento para 1 complemento
   * - BOU-UPSELL-2: descuento para 2 o más complementos
   *
   * Puedes cambiar los nombres antes de cargar este archivo:
   * window.BOU_UPSELL_DISCOUNT_CODE_1 = 'OTRO-CODIGO';
   * window.BOU_UPSELL_DISCOUNT_CODE_2 = 'OTRO-CODIGO-2';
   */

  var CODE_ONE = window.BOU_UPSELL_DISCOUNT_CODE_1 || 'BOU-UPSELL-1';
  var CODE_TWO = window.BOU_UPSELL_DISCOUNT_CODE_2 || 'BOU-UPSELL-2';

  var CART_SECTIONS = [
    'cart-notification-product',
    'cart-notification-button',
    'cart-icon-bubble',
    'cart-upsell',
    'cart-drawer-gift'
  ];

  function shopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function installStyles() {
    if (document.getElementById('bou-upsell-main-product-fix-styles')) return;

    var style = document.createElement('style');
    style.id = 'bou-upsell-main-product-fix-styles';
    style.textContent = [
      '.bou-btn-cart,.bou-upsell-card__btn{border-radius:10px!important;}',
      '.bou-upsell-card__btn{min-height:42px!important;padding:0 16px!important;background:var(--bou-gold,#d5ae43)!important;color:#080808!important;border:1px solid var(--bou-gold,#d5ae43)!important;font-size:12px!important;font-weight:800!important;letter-spacing:.5px!important;transition:all .25s ease!important;box-shadow:0 4px 16px rgba(213,174,67,.22)!important;}',
      '.bou-upsell-card__btn:hover{background:var(--bou-gold-dark,#b8902b)!important;border-color:var(--bou-gold-dark,#b8902b)!important;color:#080808!important;transform:translateY(-1px);}',
      '.bou-upsell-card__btn:disabled{opacity:.7!important;cursor:wait!important;transform:none!important;}'
    ].join('');
    document.head.appendChild(style);
  }

  function uniqueNumbers(values) {
    return values.filter(function (value, index, array) {
      return value > 0 && array.indexOf(value) === index;
    });
  }

  function collectUpsellVariantIds(btn) {
    var container = btn.closest('.bou-upsells') || document;
    var ids = [];

    var selectors = [
      'input.bou-upsell-checkbox:checked',
      'input[data-upsell-variant-id]:checked',
      'input[data-upsell-selected]:checked',
      '[data-upsell-item].is-selected',
      '[data-upsell-item][aria-checked="true"]'
    ];

    container.querySelectorAll(selectors.join(',')).forEach(function (control) {
      var raw =
        control.dataset.variantId ||
        control.dataset.upsellVariantId ||
        control.value ||
        '';

      var id = parseInt(raw, 10);
      if (id) ids.push(id);
    });

    if (!ids.length && btn.dataset && btn.dataset.variantId) {
      ids.push(parseInt(btn.dataset.variantId, 10));
    }

    return uniqueNumbers(ids);
  }

  function hasAppliedDiscount(cart, code) {
    var target = String(code || '').toUpperCase();

    var cartApplications = cart.discount_applications || [];
    var cartMatch = cartApplications.some(function (application) {
      return String(application.title || application.code || '').toUpperCase() === target;
    });

    if (cartMatch) return true;

    return (cart.items || []).some(function (item) {
      return (item.discount_allocations || []).some(function (allocation) {
        var application = allocation.discount_application || {};
        return String(application.title || application.code || '').toUpperCase() === target;
      });
    });
  }

  function renderAndOpenCart(cartState) {
    var cartNotification = document.querySelector('cart-notification');

    if (
      cartNotification &&
      cartState.sections &&
      typeof cartNotification.renderContents === 'function'
    ) {
      cartNotification.renderContents(cartState);

      if (typeof window.openCartDrawer === 'function') {
        window.openCartDrawer();
      }

      if (typeof window.initMotivatorProduct === 'function') {
        window.initMotivatorProduct();
      }

      return;
    }

    window.location.href = shopRoot() + 'cart';
  }

  function addProducts(items) {
    return fetch(shopRoot() + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || 'No se pudieron agregar los productos.');
        }
        return data;
      });
    });
  }

  function applyDiscountAndRefresh(code) {
    return fetch(shopRoot() + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        discount: code,
        sections: CART_SECTIONS,
        sections_url: window.location.pathname
      })
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || 'No se pudo aplicar el descuento.');
        }
        return data;
      });
    });
  }

  function installUpsellHandler() {
    window.bouAddUpsell = function (btn) {
      var mainVariantInput = document.getElementById('bou-variant-id');
      var qtyInput = document.getElementById('bou-qty');

      var mainId = mainVariantInput ? parseInt(mainVariantInput.value, 10) : 0;
      var mainQty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      var upsellIds = collectUpsellVariantIds(btn);

      if (!btn || !mainId || !upsellIds.length) {
        if (btn) btn.textContent = 'ERROR';
        return;
      }

      var discountCode = upsellIds.length >= 2 ? CODE_TWO : CODE_ONE;
      var originalText = btn.textContent || 'AGREGAR';

      var items = [{ id: mainId, quantity: mainQty }];
      upsellIds.forEach(function (variantId) {
        items.push({ id: variantId, quantity: 1 });
      });

      btn.disabled = true;
      btn.textContent = 'AGREGANDO...';

      addProducts(items)
        .then(function () {
          btn.textContent = 'APLICANDO DESCUENTO...';
          return applyDiscountAndRefresh(discountCode);
        })
        .then(function (cartState) {
          var applied = hasAppliedDiscount(cartState, discountCode);

          renderAndOpenCart(cartState);

          if (applied) {
            btn.textContent = '✓ DESCUENTO APLICADO';
          } else {
            btn.textContent = 'REVISAR DESCUENTO';
            console.warn(
              'BOU Upsell: Shopify no aplicó el código ' +
                discountCode +
                '. Revisa que exista, esté activo y que sus condiciones coincidan con los productos agregados.'
            );
          }

          window.setTimeout(function () {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 2600);
        })
        .catch(function (error) {
          console.error('BOU upsell:', error);
          btn.textContent = 'ERROR';

          window.setTimeout(function () {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 2600);
        });
    };
  }

  function initialize() {
    if (!document.querySelector('.bou-upsell-card__btn')) return;
    installStyles();
    installUpsellHandler();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
